import { useState } from 'react';
import { AddressableViewLayout } from 'framework/ViewTypes';
import { useAuthorization } from 'framework/authorization';
import { EditPositionFillRequestDrawer, useCancelPositionFillRequestAction } from '../createupdate';
import { POSITION_FILL_REQUEST_UPDATE } from '../constants';
import PositionFillRequestDetailsContent from './details/PositionFillRequestDetailsContent';
import usePositionFillRequestDetails from './model/usePositionFillRequestDetails';
import { useHighlightUrl } from 'framework/HighlightUrl';
import {
  ID_PFR_HIGHLIGHT,
  POSITION_FILL_REQUEST_ACTIVE,
  POSITION_FILL_REQUEST_CANCEL,
  POSITION_FILL_REQUEST_REVIEW,
} from 'domain/shared/positionFillRequest/constants';

const PositionFillRequestDetails = () => {
  const { isGranted } = useAuthorization();
  const { positionFillRequest, stateOwners, isLoading, error, reload } = usePositionFillRequestDetails();
  const [isEditOpen, setEditOpen] = useState(false);
  const { cancel } = useCancelPositionFillRequestAction(reload);
  const { reload: reloadIndicator } = useHighlightUrl();

  return (
    <AddressableViewLayout
      loading={isLoading}
      contentLayout={
        <PositionFillRequestDetailsContent
          positionFillRequest={positionFillRequest}
          stateOwners={stateOwners}
          loading={isLoading}
          error={error}
          retry={reload}
          onUpdated={() => {
            reloadIndicator(ID_PFR_HIGHLIGHT);
            reload();
          }}
          canReview={isGranted(POSITION_FILL_REQUEST_REVIEW)}
          canActivate={isGranted(POSITION_FILL_REQUEST_ACTIVE)}
          canUpdate={isGranted(POSITION_FILL_REQUEST_UPDATE)}
          canCancel={isGranted(POSITION_FILL_REQUEST_CANCEL)}
          onEdit={() => setEditOpen(true)}
          onCancel={() => positionFillRequest && cancel(positionFillRequest.id)}
        />
      }
      drawer={
        isEditOpen && positionFillRequest ? (
          <EditPositionFillRequestDrawer
            isOpen
            positionFillRequest={positionFillRequest}
            onClose={() => setEditOpen(false)}
            onSuccess={reload}
          />
        ) : undefined
      }
    />
  );
};

export default PositionFillRequestDetails;
